import { NgModule } from '@angular/core';
import { AuthRoutingModule } from './auth-routing.module';
import { LoginComponent } from './containers/login/login.component';
import { LoginFormComponent } from './components/login-form/login-form.component';
import { SharedModule } from '../../shared/shared.module';
import { UIRouterModule } from '@uirouter/angular';
import { AUTH_STATES } from './auth.states';
import { FirstSigninFormComponent } from './components/first-signin-form/first-signin-form.component';
import { PasswordStrengthPipe } from './pipes/password-strength.pipe';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';

@NgModule({
  declarations: [LoginComponent, LoginFormComponent, FirstSigninFormComponent, PasswordStrengthPipe, ResetPasswordComponent],
  imports: [

  SharedModule,
    AuthRoutingModule,
    UIRouterModule.forChild({ states: [...AUTH_STATES] })
  ]
})
export class AuthModule { }
